/** DOM events when announcements change (socket push). */
export const ANNOUNCEMENTS_UPDATED_EVENT = 'catalogofworks:announcements-updated';

export type AnnouncementsUpdatedDetail = {
  id?: string;
  deleted?: boolean;
};

export function dispatchAnnouncementsUpdated(detail: AnnouncementsUpdatedDetail = {}): void {
  window.dispatchEvent(new CustomEvent(ANNOUNCEMENTS_UPDATED_EVENT, { detail }));
}
